import type { MutationHookOptions } from '@apollo/client'
import {
  UpdateSessionRelatorioUnicoFieldDocument,
  UpdateSessionRelatorioUnicoFieldMutation,
  UpdateSessionRelatorioUnicoFieldMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpdateSessionRelatorioUnicoFieldMutation,
  UpdateSessionRelatorioUnicoFieldMutationVariables
>

export const useUpdateSessionRelatorioUnicoField = (options?: Options) => {
  const [updateSessionRelatorioUnicoField, { loading }] = useMutation(
    UpdateSessionRelatorioUnicoFieldDocument,
    {
      ...options,
      extractorFn: (data) => data.trainingsMutations.updateTrainingsSessionRelatorioUnicoField,
    }
  )

  return {
    loading,
    update(variables: UpdateSessionRelatorioUnicoFieldMutationVariables) {
      return updateSessionRelatorioUnicoField({
        variables,
      })
    },
  }
}
